import { render, staticRenderFns } from "./EditKunde.vue?vue&type=template&id=b60871c2"
import script from "./EditKunde.vue?vue&type=script&lang=js"
export * from "./EditKunde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports